/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Login_Offline_Activation_Failed_SupportInputs */

const en_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activation Failed. Please contact support for more information (${i?.email})`)
};

const fr_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activation echouee. Veuillez contacter le support pour plus d'informations (${i?.email})`)
};

const de_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktivierung fehlgeschlagen. Bitte kontaktieren Sie den Support für weitere Informationen (${i?.email}).`)
};

const it_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attivazione non riuscita. Contattare l'assistenza per ulteriori informazioni (${i?.email})`)
};

const ru_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Активация не удалась. Для получения дополнительной информации обратитесь в службу поддержки (${i?.email})`)
};

const es_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error de activación. Para más información, contacte con el soporte técnico (${i?.email}).`)
};

const zh_cn2_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`激活失败。请联系客服获取更多信息 (${i?.email})`)
};

const ja_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アクティベーションに失敗しました。詳細についてはサポートにお問い合わせください (${i?.email})`)
};

const hi_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सक्रियण विफल। अधिक जानकारी के लिए कृपया सहायता टीम से संपर्क करें (${i?.email})`)
};

const pt_pt2_login_offline_activation_failed_support = /** @type {(inputs: Login_Offline_Activation_Failed_SupportInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ativação falhou. Entre em contato com o suporte para obter mais informações (${i?.email})`)
};

/**
* | output |
* | --- |
* | "Activation Failed. Please contact support for more information ({email})" |
*
* @param {Login_Offline_Activation_Failed_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_failed_support = /** @type {((inputs: Login_Offline_Activation_Failed_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Failed_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activation_failed_support(inputs)
	if (locale === "de") return de_login_offline_activation_failed_support(inputs)
	if (locale === "it") return it_login_offline_activation_failed_support(inputs)
	if (locale === "ru") return ru_login_offline_activation_failed_support(inputs)
	if (locale === "es") return es_login_offline_activation_failed_support(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activation_failed_support(inputs)
	if (locale === "ja") return ja_login_offline_activation_failed_support(inputs)
	if (locale === "hi") return hi_login_offline_activation_failed_support(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activation_failed_support(inputs)
	return en_login_offline_activation_failed_support(inputs)
});